// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useAppDispatch } from 'store/hooks';
import { changeSelectedImage } from 'store/reducers/projectImageSlice';
import { AppRoutes } from 'utilities/router/AppRoutes';

export default function useNavigationFunctions() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id } = useParams();

  const navigateToLabel = useCallback(
    imageMd5 => {
      dispatch(changeSelectedImage(imageMd5));
      navigate(AppRoutes.ProjectLabelFullPath(id ?? ''));
    },
    [dispatch, id, navigate]
  );
  const navigateToAlgorithms = useCallback(
    imageMd5 => {
      dispatch(changeSelectedImage(imageMd5));
      navigate(AppRoutes.ProjectAlgorithmsFullPath(id ?? ''));
    },
    [dispatch, id, navigate]
  );

  return { navigateToLabel, navigateToAlgorithms };
}
